import { render, staticRenderFns } from "./spinner.vue?vue&type=template&id=0de230c3&scoped=true"
import script from "./spinner.vue?vue&type=script&lang=ts"
export * from "./spinner.vue?vue&type=script&lang=ts"
import style0 from "./spinner.vue?vue&type=style&index=0&id=0de230c3&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de230c3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0de230c3')) {
      api.createRecord('0de230c3', component.options)
    } else {
      api.reload('0de230c3', component.options)
    }
    module.hot.accept("./spinner.vue?vue&type=template&id=0de230c3&scoped=true", function () {
      api.rerender('0de230c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/spinner/spinner.vue"
export default component.exports